import {makeStyles, Theme} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    popUpOuter:{
        "& .Mui-disabled":{
         opacity: '0.6 !important',
         color: '#fff  !important',
        }, 
        "& .MuiDialog-paperWidthSm":{
         maxWidth: '600px',
         overflow: 'initial',
        },
        "& .MuiDialogTitle-root ":{
         flex: '0 0 auto',
         margin: '0',
         position: 'relative',
         padding: '16px 24px',
         //z-index: '1',
        },
        "& .MuiOutlinedInput-input":{
            float: 'left !important',
            width: '100% !important',
            padding: '10px 2px !important',
            background: '#f7fcff',
            borderRadius: '4px',
        },
 
     },
     popUpHeader:{
        backgroundImage: 'linear-gradient(to right, #890e34, #ce0623)',
        padding:'14px 12px 10px 24px !important',
        borderRadius:'0px 0px 0 0',
       "& h2":{
        color: '#fff',
        fontWeight: 'normal',
        textTransform: 'uppercase',
        position: 'relative',
       },
    },

    NoPopWrapper:{
        "& .MuiOutlinedInput-input":{
           float: 'left',
           width: '100%',
           padding: '10px 0 10px 2px',
           background: '#f7fcff',
           borderRadius: '4px',
        },
        "& .MuiFormControl-root":{
           margin: '0 10px 0 0',
        },
    },

    popUpLBL:{
        textTransform:'uppercase',
        fontSize:'12px',
        margin:'0 2px 0 0',
    },
    popUpAddBtn:{
        "& .MuiSvgIcon-root":{
         color: '#28b600',
         float: 'left',
        },
 
     },

     tblContainer: {
        // maxHeight:'375px',
    },
    tblHeader:{
        "& th": {
            //  backgroundColor:'#fbfbfb',
            backgroundColor:'#fff',
            color: '#000',
            textTransform:'uppercase',
            fontSize:'14px',
            padding:'10px 5px !important',
            fontWeight:'bold',
        },

    },
    tblBody:{
        "& th": {
            backgroundColor:'#fff',
            color: '#000',
            textTransform:'uppercase',
            fontSize:'14px',
            padding:'6px 5px !important',
        },
        "& td": {
            color: '#000',
            backgroundColor: '#fff;',
            fontSize: '14px',
            padding:'6px 5px !important',
            textTransform: 'uppercase',
            borderBottom:'1px solid #ededed !important',
        },
    },
    tblOuterBG:{
        backgroundColor: '#fff;',
        padding: '10px',
        borderRadius: '15px',
    },
    
    greenBtnWrapper:{
        float: 'right',
    margin: '-18px 0px 0 10px',
        "& button":{
            background: '#19C626 !important',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '20px',
        padding: '5px 25px',
        fontWeight:'bold',
    },
    "& .MuiButton-root:hover":{
        color: '#fff',
        fontSize: '12px',
        background: '#00b50a !important',
        borderRadius: '20px',
        padding: '5px 25px',
    },

    
    },

    grayBtnWrapper:{
        float: 'right',
    margin: '-18px 0px 0 10px',
        "& button":{
            background: '#333 !important',
    fontSize: '12px',
    color: '#fff',
    borderRadius: '20px',
        padding: '5px 25px',
        fontWeight:'bold',
    },
    "& .MuiButton-root:hover":{
        background: '#333 !important',
        fontSize: '12px',
        color: '#fff',
        borderRadius: '20px',
        padding: '5px 25px',
    },

    
    },
    downIconWrapper:{
        "& button":{

        },
        "& button:hover":{
            background:'#fff',
            
        },
        "& .MuiSvgIcon-root":{
            color:'#0059ea',
        },

    },


}));

export default  useStyles;